// MeetingTitle.js
import { Box } from "@mui/material";
import { useTemplateFontSettings } from 'styles/templateFontSettings';

const DshBoxTitle = ({ title, color = "primary", secondTitle }) => {
    const { baseFontSize } = useTemplateFontSettings();

    const content = (
        <Box sx={{ position: 'relative', textAlign: 'center', width: '100%' }}>
            <span>{title}</span>
            {secondTitle !== undefined && (
                <span
                    style={{
                        fontStyle: 'italic',
                        position: 'absolute',
                        right: 0,
                        top: '50%',
                        transform: 'translateY(-50%)'
                    }}
                >
                    {secondTitle}
                </span>
            )}
        </Box>
    );

    return (
        color === "primary" ?
            <Box
                gutterBottom
                sx={{
                    fontSize: baseFontSize,
                    color: "primary.main",
                    textAlign: "center",
                    fontWeight: 450,
                    backgroundColor: '#eef2ff',
                    py: 1,
                    borderRadius: 1,
                    mb: 2
                }}
            >
                {content}
            </Box>
            : color === "blue" ?
                <Box
                    gutterBottom
                    sx={{
                        fontSize: baseFontSize,
                        color: "#2EB5C9",
                        textAlign: "center",
                        fontWeight: 450,
                        backgroundColor: "rgba(46,181,201,0.1)",
                        py: 1,
                        borderRadius: 1,
                        mb: 2
                    }}
                >
                    {content}
                </Box>
                : color === "subheader" ?
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Box
                            gutterBottom
                            sx={{
                                fontSize: baseFontSize,
                                color: "primary.main",
                                textAlign: "center",
                                fontWeight: 400,
                                backgroundColor: '#eef2ff',
                                py: 0.7,
                                borderRadius: 10,
                                mb: 2,
                                width: "25%"
                            }}
                        >
                            {content}
                        </Box>
                    </div>
                    : color === "warning" ?
                        <Box
                            gutterBottom
                            sx={{
                                fontSize: baseFontSize,
                                color: "warning.main",
                                textAlign: "center",
                                fontWeight: 450,
                                backgroundColor: '#eef2ff',
                                py: 1,
                                borderRadius: 1,
                                mb: 2
                            }}
                        >
                            {content}
                        </Box>
                        : color === "error" ?
                            <Box
                                gutterBottom
                                sx={{
                                    fontSize: baseFontSize,
                                    color: "#E73145",
                                    textAlign: "center",
                                    fontWeight: 450,
                                    backgroundColor: "#ffe5e9",
                                    py: 1,
                                    borderRadius: 1,
                                    mb: 2
                                }}
                            >
                                {content}
                            </Box>
                            :
                            <Box
                                gutterBottom
                                sx={{
                                    fontSize: baseFontSize,
                                    color: "primary.main",
                                    textAlign: "center",
                                    fontWeight: 450,
                                    backgroundColor: '#eef2ff',
                                    py: 1,
                                    borderRadius: 1,
                                    mb: 2
                                }}
                            >
                                {content}
                            </Box>
    );
};

export default DshBoxTitle;
